import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
//import Table from "./Table";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faTimes,
  faPen,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import styles from "../master.css";
import apiUrl from "../../apiUrlConstant";
import { Redirect, withRouter, Link } from "react-router-dom";
import UtilityChargesTable from "./UtilityChargesTable";
import Popup from "reactjs-popup";
import { PopupMessage } from "../../utils/utils";

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

class UtilityCharges extends React.Component {
  state = {
    isOpen: false,
    redirect: false,
    messsagePopup: false,
    popupContent: "Data Saved Successfully!",
    popupalertMessage: false,
    popupMessageContent: '',
    delete: false,
    url: `${apiUrl.apiUrl.url}/utility-charges-logic/create`,
    id: undefined,
    initialValues: {
      utility_charges_logic_name: "",
      effective_from: "",
      utility_charges_logic_formula: "",
    },
  };

  constructor(props) {
    super(props);
  }

  checkDelete() {
    var self = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/utility-charges-logic/check-delete?id=${this.state.id}`,
    }).then(function (response) {
      if (!response.data.success) {
      } else {
        // if (window.confirm("Are You Sure You Want to Delete the item?")) {
        //   axios({
        //     method: "get",
        //     url: `${apiUrl.apiUrl.url}/utility-charges-logic/delete?id=${self.state.id}`,
        //   }).then(function (response) {
        //     if (!response.data.success) {
        //       alert("Something Went Wrong");
        //     } else {
        //       alert("Data Deleted Successfully");
        //       self.setState({ redirect: true });
        //     }
        //   });
        // }
        self.setState({
          delete: true,
        });
      }
    });
  }

  componentDidUpdate() {
    if (this.props.match.params.id != this.state.id) {
      this.state.id = this.props.match.params.id;
      if (this.props.match.params.id === undefined) {
        this.setState({
          url: `${apiUrl.apiUrl.url}/utility-charges-logic/create`,
          initialValues: {
            utility_charges_logic_name: "",
            effective_from: "",
            utility_charges_logic_formula: "",
          },
        });
      } else {
        fetch(
          `${apiUrl.apiUrl.url}/utility-charges-logic/fetch-logic?id=${this.props.match.params.id}`,
          {headers}
        )
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            this.setState({
              url: `${apiUrl.apiUrl.url}/utility-charges-logic/update?id=${this.props.match.params.id}`,
              initialValues: data.data,
            });
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  }
  redirectAfterSave = () => {
    this.setState({
      redirect: true, messsagePopup: false,
      initialValues: {
        utility_charges_logic_name: "",
        effective_from: "",
        utility_charges_logic_formula: "",
      },
    });
  };

  redirectAfterEdit = () => {
    this.setState({
      redirect: true, messsagePopup: false,
      initialValues: {
        utility_charges_logic_name: "",
        effective_from: "",
        utility_charges_logic_formula: "",
      },
    });
  };

  redirectToDelete = () => {
    this.setState({
      delete: false,
    });
    var self = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/utility-charges-logic/check-delete?id=${this.state.id}`,
    }).then(function (response) {
      if (!response.data.success) {
        // alert("Something Went Wrong");
        self.setState({
          popupalertMessage: true,
          popupMessageContent: 'Something Went Wrong',
        });
      } else {
        // alert("Data Deleted Successfully");
        self.setState({
          messsagePopup: true,
          popupContent: 'Data Deleted Successfully'
        });
      }
    });

  };
  redirectToClose = () => {
    this.setState({
      delete: false,
      popupalertMessage: false,
      popupMessageContent: '',
    });
  };

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to="/masters/utility-charges" />;
    }
    return (
      <div className="parentContainer">
        {this.renderForm()}
      </div>
    );
  }

  renderForm() {
    return (
      <>
        <div className="absoluteItemForTopBar">
          <div className="new_breadcrumbs_design">
            <ul className="d-flex align-items-center gap-3 p-0 m-0">
              <li>
                <Link to="/masters">Masters</Link>
              </li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <Link to="/masters/charges-master">Charges Master</Link>
              </li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <Link to="#">Utility Charges</Link>
              </li>
            </ul>
          </div>
        </div>

        <Formik
          initialValues={this.state.initialValues}
          enableReinitialize
          onSubmit={(values, actions) => {
            console.log(values);
            var self = this;
            axios({
              method: "post",
              url: this.state.url,
              data: values,
            }).then(function (response) {
              if (!response.data.success) {
                // alert("Data Saved Successfully");
                actions.setSubmitting(false);

                actions.setErrors(response.data);
              } else {
                self.setState({
                  messsagePopup: true,
                  popupContent: 'Data Saved Successfully'
                });
              }
            });
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
          }) => (
            <>
              <div className="unitFormContainerNew">
                <Form autoComplete="off" >
                  <div className="newGridSectionParent">
                    <div className="newGridSectionForFormMain">

                      <div className="newGridSectionInner">
                        <label>
                          Name <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field type="text" name="utility_charges_logic_name" />
                          <ErrorMessage
                            name="utility_charges_logic_name"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Effective From <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field type="date" name="effective_from" />
                          <ErrorMessage
                            name="effective_from"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Formula <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field
                            as="textarea"
                            name="utility_charges_logic_formula"
                            className="details"
                          />
                          <ErrorMessage
                            name="utility_charges_logic_formula"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                    </div>

                    {this.props.match.params.id !== undefined ? (
                      <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                        <button type="submit" className="update_button" disabled={isSubmitting}>
                          Update
                        </button>
                        <button
                          className="delete_button"
                          type="button"
                          onClick={(e) => {
                            this.checkDelete(e);
                          }}>
                          Delete
                        </button>
                        <button type="reset" className="reset_button" onClick={this.redirectAfterEdit}>
                          <Link to="/masters/utility-charges">
                            Reset
                          </Link>
                        </button>
                      </div>
                    ) : (
                      <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                        <button type="submit" className="add_button" disabled={isSubmitting}>
                          Add
                        </button>
                        <button type="reset" className="reset_button" onClick={this.redirectAfterEdit}>
                          Reset
                        </button>
                      </div>
                    )}
                  </div>
                </Form>
              </div>


              {/* <div className="unitFormContainerNew">
                <Form autoComplete="off" >
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Name <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field
                                type="text"
                                name="utility_charges_logic_name"
                              />
                              <ErrorMessage
                                name="utility_charges_logic_name"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Effective From <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field type="date" name="effective_from" />
                              <ErrorMessage
                                name="effective_from"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Formula<span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field
                                as="textarea"
                                name="utility_charges_logic_formula"
                                className="details"
                              />
                              <ErrorMessage
                                name="utility_charges_logic_formula"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {this.props.match.params.id !== undefined ? (
                      <div className="row">
                        <div className="col-lg-6 offset-lg-6">
                          <div className="btnContainer">
                            <div>
                              <button type="submit" disabled={isSubmitting}>
                                Update
                              </button>
                              <button
                                type="button"
                                onClick={(e) => {
                                  this.checkDelete(e);
                                }}
                              >
                                Delete
                              </button>
                              <button type="reset" onClick={this.redirectAfterEdit}>
                                <Link to="/masters/utility-charges">
                                  Reset
                                </Link>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="row">
                        <div className="col-lg-6 offset-lg-6">
                          <div className="btnContainer">
                            <div>
                              <button type="submit" disabled={isSubmitting}>
                                Add
                              </button>
                              <button type="reset" onClick={this.redirectAfterEdit}>
                                Reset
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </Form>
              </div> */}
            </>
          )}
        </Formik>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.delete} position="top center">
          {(close) => (
            <div>
              "Are you sure you want to delete this item?"
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
              <div>
                <button type="button" onClick={this.redirectToDelete}>
                  Yes
                </button>
              </div>
            </div>
          )}
        </Popup>
        <Popup open={this.state.popupalertMessage} position="top center">
          {(close) => (
            <div>
              {this.state.popupMessageContent}
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
            </div>
          )}
        </Popup>
        <UtilityChargesTable />
      </>
    );
  }
}

export default withRouter(UtilityCharges);
